let mutations = {
    SET_IMAGES(state, images) {
        state.images = images
	},
	SET_IMAGE(state, image) {
        state.image = image
    },
    SET_PAGES(state, pages) {
        state.pages = pages
    },
    SET_PAGE(state, page) {
        state.page = page
    },
    SET_SELECTED_IMAGE_IDS(state, imageIds) {
    	state.selectedImageIds = imageIds
    },
    ADD_TO_SELECTED_IMAGE_IDS(state, imageId) {
        state.selectedImageIds.push(imageId)
    },
    REMOVE_FROM_SELECTED_IMAGE_IDS(state, imageId) {
    	state.selectedImageIds.splice(state.selectedImageIds.indexOf(imageId), 1);
    },
    SET_PREVIEW_ANNOTATIONS(state, previewAnnotations) {
        state.previewAnnotations = previewAnnotations
    },
    SET_SEARCH_PARAMS(state, searchParams) {
        state.searchParams = searchParams
    },
    SET_IS_SEARCHING_FLAG(state, isSearching) {
        state.isSearching = isSearching
    },
    SET_IS_SEARCHED_FLAG(state, isSearched) {
        state.isSearched = isSearched
    },
    SET_CANCEL_SOURCE_FOR_SEARCH(state, cancelSourceForSearch) {
        state.cancelSourceForSearch = cancelSourceForSearch
    },
}

export default mutations